class CustomClaimTypes {
    static readonly can_change_password = 'urn:cv:can_change_password';
    static readonly customer_id = 'urn:cv:customer_id';
    static readonly person_id = 'urn:cv:person_id';
    static readonly has_multiple_customers = 'urn:cv:has_multiple_customers';
}

export default CustomClaimTypes;
